<script lang="ts">
  import { ArrowLeft, Search, Plus, Menu } from 'lucide-svelte';

  const {
    title,
    subtitle,
    showBack = false,
    onBack,
    search,
    onSearch,
    onNewQuote,
    onMenuClick
  }: {
    title: string;
    subtitle: string;
    showBack?: boolean;
    onBack?: () => void;
    search?: string;
    onSearch?: (v: string) => void;
    onNewQuote?: () => void;
    onMenuClick?: () => void;
  } = $props();
</script>

<header
  class="bg-[var(--tym-white)] border-b border-toyama-cloudy-gray min-h-[66px] shrink-0 flex items-center justify-between gap-3 px-4 lg:gap-5 lg:px-7"
>
  <div class="flex items-center gap-2.5 min-w-0 lg:gap-3.5">
    <button
      type="button"
      class="btn-secondary !h-10 !w-10 !p-0 lg:hidden shrink-0"
      onclick={onMenuClick}
      aria-label="Open menu"
    >
      <Menu class="h-[18px] w-[18px]" />
    </button>
    {#if showBack}
      <button type="button" class="btn-secondary !py-1.5" onclick={onBack}>
        <ArrowLeft class="h-[15px] w-[15px]" />
        Pipeline
      </button>
    {/if}
    <div class="min-w-0">
      <h1 class="font-heading font-bold text-[21px] text-navy tracking-tight leading-[1.1] truncate">{title}</h1>
      <div class="text-[12.5px] text-dark-gray mt-0.5 truncate">{subtitle}</div>
    </div>
  </div>

  <div class="flex items-center gap-2.5 shrink-0 lg:gap-3">
    {#if onSearch}
      <div class="relative flex items-center">
        <Search class="h-4 w-4 absolute left-[11px] text-dark-gray pointer-events-none" />
        <input
          value={search}
          oninput={(e) => onSearch?.((e.currentTarget as HTMLInputElement).value)}
          placeholder="Search quotes, clients…"
          class="input !w-[140px] sm:!w-[230px] !py-2.5 !pl-8 !pr-3 !text-[13px]"
        />
      </div>
    {/if}
    {#if onNewQuote}
      <button type="button" class="btn-primary" onclick={onNewQuote}>
        <Plus class="h-4 w-4" />
        <span class="hidden sm:inline">New quote</span>
      </button>
    {/if}
  </div>
</header>
